import React, { Component } from 'react'
import { Input, Pagination, Checkbox, Button, Icon, Switch } from '@tinper/next-ui'
import _ from 'lodash';
import './style';
import { REFER_TYPE } from '../../utils/refer_context/referType';
import { getJsonObj, removeRepeat, flatArr } from '../../utils';
import { v4 as uuid } from 'uuid';
import { TableStore, RowStore, PageStore } from 'ynf-core-engine'
import render from 'ynf-core-engine/render'

const X_LIB_CODE = 'ynf-lib-base' // 组件库名

export default class SearchTable extends Component {
  constructor (props) {
    super(props);
    this.referContext = props.referContext;
    try {
      this.billNo = this.referContext.props.pageStore.params.billNo;
      this.busiObj = this.referContext.props.pageStore.params.busiObj;
      this.referType = this.referContext.metaDataObj.referType
    } catch {
      console.error("没配置pageStore!")
    }
    this.key = this.referContext.metaDataObj.cEntityKeyFld || 'id'; // 参照主键
    this.rootStore = {}
    this.rootStore.referTableStore = new TableStore({}, this.rootStore, null, this.key)
    this.rootStore.pageStore = new PageStore({ ...this.referContext.props.pageStore, enumData: this.referContext.metaDataObj.enumData })
  }

  state = {
    dataSource: [], // 列表数据
    totalDataSource: [], // 全部数据
    selectedKeys: [], // 当前选中数据的id集合
    selectedList: [], // 当前选中数据集合
    alias: uuid(), // 别名
    searchResultData: [], // 搜索结果数据(前端分页搜索时用)
  }

  componentDidMount () {
    this.getAllDataList(this.props.searchKey); // 获取全部数据
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchKey) {
      this.getAllDataList(nextProps.searchKey)
    }
  }

  // 获取全部数据
  getAllDataList = async (searchKey) => {
    this.referContext.props.pageStore.startLoading()
    let _res = await this.referContext.getListData({
      pageInfo: this.referType === 'Tree' ? undefined : { pageIndex: 1, pageSize: 1000, total: 0 },
      searchKey,
      exactQuery: false, // 精准搜索
      referType: ['TreeTable', 'Table'].includes(this.referType) ? 'Table' : 'Tree',
      dataType: this.referType === 'Tree' ? 'tree' : 'grid',
      path: this.props.path === 'all' ? '' : this.props.path,
      billnum: this.billNo,
      busiObj: this.busiObj
    });
    let totalDataSource = []
    if (this.referType === 'Tree') {
      totalDataSource = flatArr(_res, 'children')
    } else {
      totalDataSource = _res.dataSource
    }
    this.setState({ totalDataSource, dataSource: totalDataSource });
    this.referContext.props.pageStore.endLoading()
  }

  // 监听选择
  onSelectRow = (row) => {
    this.referContext.props.onChangeSelect?.({
      oldValue: this.referContext.getCurrentValue(),
      currentValue: row
    });
    const { dataSource } = this.state;
    this.referContext.selectWithOk(row) // 将选择的值存入逻辑层
    // 更新选择数据
    let selectRowData = this.referContext.getCurrentValue();
    let selectedKeys = selectRowData.map(item => item[this.key]);
    this.setState({ selectedKeys });
  }

  // 渲染列表配置项
  getTableConfig = () => {
    const { fieldid, fieldidPrefix } = this.referContext.props || {};
    const { alias, selectedList, dataSource = [] } = this.state;
    this.rootStore.referTableStore.clear() // 先清空
    dataSource.map((item, index) => {
      this.rootStore.referTableStore.addRow(new RowStore(index, item))
    })
    let columns = !this.props.newRefMeta ? this.getTableColumn(this.props.metaData) : {};
    let config = {
      fieldid,
      fieldidPrefix,
      store: this.rootStore.referTableStore,
      libCode: X_LIB_CODE, // 组件库
      controlType: 'Table', // 组件类型
      alias: this.props.path ? this.props.path : alias, // 组件唯一标识 有path是树表, 树表切换时不能用同一个alias
      children: columns.columns,
      isSort: true, // 表格排序
      isSingleFind: false, // 该列是否启用查找定位
      readOnly: true,
      autoCheckedByClickRows: true, // 表格行点击事件，是否自动勾选
      lockable: false, // 是否开启锁定列功能
      onRowClick: (record, index, event) => { // 行的点击事件钩子函数 record : 当前行的数据
        let selectedList = record.rowStore.getValue();
        if (!this.props.isMultiple) { // 单选
          selectedList ? this.onSelectRow([selectedList]) : this.onSelectRow([])
        } else { // 多选
          this.onSelectRow(removeRepeat([...this.referContext.getCurrentValue(), selectedList], this.key));
        }
      }
    }
    if (this.props.newRefMeta) { // 新协议
      config.children = this.getTableColumn(this.props.metaData).columns;
      if (this.referType === 'Tree') {
        try {
          // const fieldArr = [...new Set([...this.referContext.props.refReturn, this.referContext.metaDataObj.cEntityNameFld, this.referContext.metaDataObj.cEntityKeyFld])]
          const fieldArr = [...new Set([...this.referContext.props.refReturn, this.referContext.metaDataObj.cEntityNameFld])]
          const fieldMap = this.referContext.metaDataObj.entities.find(e => e.controlType === 'datasourceList').children.find(e => e.dataPattern == 'TREE').fieldsArr.reduce((acc, obj) => {
            acc[obj.field] = obj; // 使用 field 属性作为键，整个对象作为值
            return acc;
          }, {})
            config.children = fieldArr.map((field) => ({
              'libCode': 'ynf-lib-base',
              'visible': true,
              'nid': 'nid_2',
              'caption': fieldMap[field].caption,
              'orderNum': 1,
              'serialCode': '1868629993090187270',
              'store': 'tableStore',
              'required': false,
              'parentSerialCode': '1868629993090187269',
              'compType': 'xcontrol',
              'controlType': 'Input',
              'iColWidth': 1,
              'storeField': 'name',
              'alias': 'input3',
              'disabled': false,
              'parentNidArr': [
                  'nid_64',
                  'nid_0',
                  'nid_1'
              ],
              'value': `mobx://rowStore.getValue('name')`
            }))
        } catch (error) {}
      }
    }
    return config;
  }
  // 表头数据
  getTableColumn = (metaData) => {
    let billno = '';
    metaData = this.referType === 'TreeTable' ? metaData?.table : metaData
    let columns = metaData?.filter(item => !item.bHidden && item.controlType?.toLocaleLowerCase() !== 'toolbar').map(item => { // columns metaData元数据
      item = JSON.parse(JSON.stringify(item))
      item.alias = 'yyrefertablecolunm' + uuid();
      item.sorter = true; // 列排序
      item.readOnly = true; // 全都是只读不能修改
      item.store = 'referTableStore';
      // 该列不展示
      if (item.bShowIt === false || item.visible === false) item.ifshow = false;
      else item.ifshow = true;
      if (item.bJointQuery) { // 要跳转的列
        item.isHref = true; // 设为可点击的链接
        const cExtProps = getJsonObj(item.cExtProps);
        const jointQueryOpt = getJsonObj(cExtProps.jointQueryOpt)
        billno = jointQueryOpt.billno
      }
      if (this.props.newRefMeta) { // 新协议
        if (item.modelPath) item.storeField = item.modelPath[item.modelPath.length - 1];
        if (item.controlType === 'PictureUpload' || item.controlType === 'Upload') item.showType = '2';
        if (item.controlType === 'Enumerate') item.enumData = `mobx://rootStore.pageStore.enumData.${item.enumType}`;
      } else {
        item.modelPath = [item.cItemName];
        item.storeField = item.cItemName;
        if (item.cControlType === 'tag' || item.cControlType === 'refer') { // 渲染该列为参照组件
          item.controlType = 'ReferInput'
          item.libCode = 'ynf-fw-apcom-lib';
          item.caption = item.cShowCaption;
          let refReturn = item.refReturn || 'name';
          item.refReturnArr = `{"${refReturn}": "${item.store},${item.cItemName}"}`;
        } else if (item.cControlType === 'optionwidget' || item.cControlType === 'Radio') { // 渲染该列为枚举组件
          item.controlType = 'Enumerate'
          item.libCode = 'ynf-lib-base';
          item.caption = item.cShowCaption
        } else {
          item.controlType = 'Input'
          item.libCode = 'ynf-lib-base';
          item.caption = item.cShowCaption
        }
      }
      return item
    }) || [];
    return { columns, billno }
  }

  render () {
    const { dataSource, selectedKeys } = this.state;
    const { parentAlias = '' } = this.referContext.props;
    const { alias } = this.referContext.props;
    return (
      <div className='refer-table-list'>
        {
          render({
            ...this.getTableConfig()
          }, {
            rootStore: this.rootStore
          })
        }
      </div>
    )
  }
}
